module.exports = __webpack_public_path__ + "img/wrong_transfer.437227f4.svg";